"use strict";


const baseURL = "https://backend.arrows.net";
const builderAnalytics = false;

Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.baseURL = baseURL; 
exports.builderAnalytics = builderAnalytics;
